import { useFormik } from 'formik';
import { ReactElement, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import * as Yup from 'yup';

import { createUrl, request, useFormikHandles } from 'app/utils';
import { Box, Flex, HelperText, Loading, Page, Typography } from 'components';
import Alert, { useAlert } from 'features/alert';
import { AuthButton, AuthInput2 } from 'features/auth/components';
import { useSchool } from 'features/school';

const ConfirmNewEmailForChangeView = (): ReactElement => {
  const { apiGatewayUrl } = useSchool();
  const { setAlert, clearAlert } = useAlert();
  const navigate = useNavigate();
  const { recoveryToken } = useParams();

  const initialValues: Record<string, any> = {
    confirmationCode: '',
  };

  const formik = useFormik({
    initialValues,
    validationSchema: Yup.object({
      confirmationCode: Yup.string().required('Você precisa informar o código de confirmação.'),
      // .matches(
      //   /^(?=.*[A-Za-z])(?=.*\d)(?=.*[%?!@#$&*])[A-Za-z\d%?!@#$&*]{8,}$/,
      //   'Por segurança, sua senha deve conter no mínimo 8 caracteres sendo pelo menos 1 letra maiúscula, 1 letra minúscula, 1 número e um caractere especial (%?!@#$&*).'
      // ),
    }),
    onSubmit: (values, { setSubmitting, resetForm }) => {
      const { confirmationCode } = values;

      request<{
        needToConfirmPreviousEmail: boolean;
        authenticationResult: number;
        message: string;
      }>({
        url: `/api/v1/User/ConfirmNewEmailByToken/${recoveryToken}`,
        method: 'post',
        baseURL: apiGatewayUrl,
        data: {
          confirmationCode,
        },
      })
        .then(({ data }) => {
          if (data.authenticationResult === 0) {
            setSubmitting(false);
            resetForm();

            navigate('/login');

            setTimeout(() => {
              setAlert({
                type: 'success',
                message: data.message,
              });
            }, 50);
          } else {
            setAlert({
              type: 'error',
              message: data.message,
            });
          }
        })
        .finally(() => {
          setSubmitting(false);
        });
    },
  });

  const { formikHandleFocus, formikHandleBlur, formikHandleChange } = useFormikHandles(formik);

  useEffect(() => {
    return () => {
      clearAlert(); // Clear Alert
    };
  }, []);

  return (
    <Page title="Login">
      {formik.isSubmitting && <Loading alpha />}

      <Alert />

      <form onSubmit={formik.handleSubmit}>
        <Flex flexDirection="column">
          <Flex flexDirection="column" px={{ m: 30, d: 45 }} pt={{ m: 30, d: 45 }}>
            <Typography type="type6" color="authLabelColor" fontWeight="bold">
              Confirme seu novo e-mail
            </Typography>

            <Flex flexDirection="column" mt={2}>
              {/* password */}
              <Flex flexDirection="column" mt={{ m: 30, d: 30 }}>
                <Typography type="type2" color="authLabelColor" upper fontWeight="bold">
                  Código de confirmação do novo e-mail
                </Typography>

                <Box position="relative" mt={2}>
                  <AuthInput2
                    name="confirmationCode"
                    type="text"
                    onChange={formikHandleChange}
                    onFocus={formikHandleFocus}
                    onBlur={formikHandleBlur}
                    value={formik.values.confirmationCode}
                    data-haserror={formik.touched.confirmationCode && formik.errors.confirmationCode}
                    tabIndex={2}
                    style={{ paddingRight: 50 }}
                  />
                </Box>

                {formik.touched.confirmationCode && formik.errors.confirmationCode && (
                  <HelperText type="error">{formik.errors.confirmationCode}</HelperText>
                )}
              </Flex>
            </Flex>
          </Flex>

          <Flex mt={5}>
            <AuthButton disabled={formik.isSubmitting} type="submit">
              Enviar
            </AuthButton>
          </Flex>

          <Flex bg="authBackground" justifyContent="center" py={3}>
            <Link to={createUrl('login')}>
              <Typography className="btn-auth-external" color="authFloatLinkColor">
                Voltar para o login
              </Typography>
            </Link>
          </Flex>
        </Flex>
      </form>
    </Page>
  );
};

export default ConfirmNewEmailForChangeView;
